export default __webpack_public_path__ + "static/media/Trailer1.5f2aec64.jpg";